import React, { Component } from 'react';
import Big from 'big.js';
import amountImage from 'assets/images/Bucket.png';
import packageImage from 'assets/images/Trowel.png';
import styles from './styles';
import { css } from 'aphrodite';
import { Button, Title, Product } from 'library';
import ReactToPrint from 'react-to-print';

class Calculation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPackagingError: false,
            isImperialSystem: props.isImperialSystem,
            isReady: props.isReady,
            product: props.selectedProduct,
            area: props.area,
            tilesDimensions: props.tilesDimensions,
            jointDimensions: props.jointDimensions,
            productWeight: null,
            productPackage: [],
            showResult: props.showResult,
            BreakdownProductName: props.BreakdownProductName,
            BreakdownRatio: props.BreakdownRatio,
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isImperialSystem !== this.props.isImperialSystem) {
            this.setState({isImperialSystem: this.props.isImperialSystem, isPackagingError: false});
        }
        if(prevProps.isReady !== this.props.isReady) {
            this.setState({isReady: this.props.isReady});
        }
        if(prevProps.product !== this.props.product) {
            this.setState({product: this.props.product});
        }
        if(prevProps.area !== this.props.area) {
            this.setState({area: this.props.area});
        }
        if(prevProps.tilesDimensions !== this.props.tilesDimensions) {
            this.setState({tilesDimensions: this.props.tilesDimensions});
        }
        if(prevProps.jointDimensions !== this.props.jointDimensions) {
            this.setState({jointDimensions: this.props.jointDimensions});
        }
        if(prevProps.showResult !== this.props.showResult) {
            this.setState({showResult: this.props.showResult});
        }
    }

    onShowResult(){
        this.props.onShowResult();
    }

    handleDoCalculation(e) {
        e.preventDefault();

        const { dataLayer } = this.props;
        let tileWidth = 0;
        let tileLength = 0;
        let tileAreaMax = 0;

        if(this.state.isReady) {
            let { jointWidth, jointDepth } = this.state.jointDimensions;

            //Weight
            const tilesDimensions = this.state.tilesDimensions;
            let productWeight = 0;
            if(tilesDimensions.length === 1) {
                productWeight = Number(this.getProductWeightByArea(tilesDimensions[0].tilesWidth, tilesDimensions[0].tilesHeight, this.state.area));
                tileWidth = Number(tilesDimensions[0].tilesWidth);
                tileLength = Number(tilesDimensions[0].tilesHeight);
            } else {
                for(let i=0; i < tilesDimensions.length; i++) {
                    productWeight += Number(this.getProductWeightByArea(tilesDimensions[i].tilesWidth, tilesDimensions[i].tilesHeight, tilesDimensions[i].area));

                    if (Number(tilesDimensions[i].area) > tileAreaMax) {
                        tileAreaMax = Number(tilesDimensions[i].area);
                        tileWidth = Number(tilesDimensions[i].tilesWidth);
                        tileLength = Number(tilesDimensions[i].tilesHeight);
                    }
                }
            }
            this.setState({productWeight});
            //Packaging
            let packaging = this.state.product.entity.fieldPackaging.filter(pack=>pack.entity.fieldMetricImperial === (this.state.isImperialSystem ? "imperial" : "metric"));

            if(packaging.length === 0) {
                this.setState({isPackagingError: true, showResult: true});
            } else {
                packaging = packaging.map((pack)=>{
                    let entity = pack.entity;
                    entity.quantity = 0;
                    return entity;
                });
                packaging.sort(function(a, b){
                    if(a.fieldQuantity && b.fieldQuantity) {
                        return a.fieldQuantity - b.fieldQuantity;
                    }
                    return 0;
                });
                let productPackage = this.getProductPackage(productWeight, packaging, false);
                productPackage = this.optimizePackages(productPackage);
                productPackage = productPackage.filter(pack=>pack.quantity>0);
                productPackage.sort(function(a, b){
                    if(a.fieldQuantity && b.fieldQuantity) {
                        return b.fieldQuantity - a.fieldQuantity;
                    }
                    return 0;
                });
                this.setState({productPackage, showResult: true},()=>{
                    this.onShowResult();
                })
            }

            if (dataLayer !== null) {
                dataLayer.push({
                    'event' : 'GCresult',
                    'GCtype': this.state.product.entity.entityLabel,
                    'GCfloorArea': Number(this.state.area),
                    'GCtileLength': tileLength,
                    'GCtileWidth': tileWidth,
                    'GCjointDepth': Number(jointDepth),
                    'GCjointWidth': Number(jointWidth),
                    'GCresult' : Number(productWeight),
                    'GCunit': this.state.isImperialSystem ? 'lbs' : 'kg'
                });

                // console.log(dataLayer);
            }
        } else {
            this.props.onThrowError();
        }
    }

    getProductPackage(remainingWeight, packages, getGreater) {
        if(getGreater) {
            if(remainingWeight === 0) {
                return packages;
            }
            for(let i=0; i<packages.length; i++) {
                if(packages[i]["fieldQuantity"]>=remainingWeight) {
                    packages[i].quantity++;
                    return packages;
                }
            }
        } else {
            for(let i=packages.length-1; i>=0; i--) {
                if(packages[i]["fieldQuantity"]<=remainingWeight) {
                    packages[i].quantity++;
                    let newRemainingWeight = remainingWeight - packages[i]["fieldQuantity"];
                    return this.getProductPackage(newRemainingWeight, packages, false);
                }
            }
            return this.getProductPackage(remainingWeight, packages, true);
        }
    }

    optimizePackages(packages) {
        for(let i=0; i<packages.length; i++) {
            let amount = packages[i].quantity * packages[i].fieldQuantity;
            for(let j=packages.length-1; j>i; j--) {
                let diff = Math.floor(amount / packages[j].fieldQuantity);
                if(diff >= 1) {
                    let qty = diff * packages[j].fieldQuantity / packages[i].fieldQuantity;
                    packages[i].quantity = packages[i].quantity - qty;
                    packages[j].quantity = packages[j].quantity + diff;
                }
            }
        }
        return packages;
    }

    cleanNumbers(nbr) {
        return parseFloat(nbr.toString().replace(',','.').replace(' ',''))
    }

    getProductWeightByArea(tilesWidth, tilesHeight, area) {
        const { unitSystem } = this.props;

        // Create some constants for UK/US to SI metric system
        let { fieldLossRatio, fieldDilutionRation, fieldProductDensity ,fieldBreakdownRatio, fieldBreakdownProductName } = this.state.product.entity;
        let { jointWidth, jointDepth } = this.state.jointDimensions;
        
        console.log(fieldBreakdownProductName);
        const imperialConversionRatio = new Big(8.3454).times(new Big(1/12));
        var productDensityConversion;

        if (this.state.isImperialSystem) {
            /**
             - US Imperial System: Metric system formula * 8,3454 (Lb/gal / Kg/L) * 7,481 (gal/ft³) * 1/12 (ft/in)
             - UK Imperial System: Metric system formula * 10,02241 (Lb/gal / Kg/L) * 6,229 (gal/ft³) * 1/12 (ft/in)
             */
            var imperialGallonRatio = unitSystem === "imperialus" ? 8.3454*7.481 :  10.02241*6.229;
            productDensityConversion = new Big(imperialGallonRatio).times(new Big(1/12));
        } else {
            // No Conversion for SI to SI
            productDensityConversion = 1;
        }



        fieldLossRatio = this.cleanNumbers(fieldLossRatio);
        fieldDilutionRation = this.cleanNumbers(fieldDilutionRation);
        fieldProductDensity = this.cleanNumbers(fieldProductDensity);
        jointWidth = this.cleanNumbers(jointWidth);
        jointDepth = this.cleanNumbers(jointDepth);
        tilesWidth = this.cleanNumbers(tilesWidth);
        tilesHeight = this.cleanNumbers(tilesHeight);
        area = this.cleanNumbers(area);
        
        /**
         * FORMULA DETAIL :
         *
         * Base : LossRatio * DilutionRatio * ProductDensity * productDensityConversion * Area
         *
         * VolumeByArea_n  : ( TileLength(mm) + TileWidth(mm) + JointWidth(mm) )  * JointWidth(mm) * JointDepth(mm)
         * VolumeByArae_d : ( ( TileLength(mm) + JointWidth(mm) ) * ( TileWidth(mm) + JointWidth(mm) ) )
         *
         * Total = Base * VolumeByArea_n / VolumeByArae_d
         */

        let base = new Big(fieldLossRatio)
            .times(new Big(fieldDilutionRation))
            .times(new Big(fieldProductDensity))
            .times(new Big(productDensityConversion))
            .times(new Big(area))
            //.times(new Big(areaConversion));

        let volumeByArea = (
                (new Big(tilesHeight).plus(new Big(tilesWidth)).plus(new Big(jointWidth)))
                    .times(new Big(jointWidth))
                    .times(new Big(jointDepth))
            )
            .div(
                (new Big(tilesHeight).plus(new Big(jointWidth)))
                .times((new Big(tilesWidth).plus(new Big(jointWidth))))
            );
        
        let total =  base.times(volumeByArea).toString();
        if(fieldBreakdownRatio !== null && fieldBreakdownProductName !== null){
            total = (new Big(total).div(fieldBreakdownRatio))
            return total;
        }
        return total;
        
    }

    render() {
        const {
            linkTitle,
            buttonLabel,
            title,
            totalLabel,
            packagedLabel,
            orLabel,
            printButtonLabel,
            findDistributorButtonLabel,
            findDistributorLink,
            legalParagraph,
            ofLabel,
            inactiveButtonLabel,
            printContainerRef,
            dataLayer,
            locale,
            
        } = this.props;
        

        return (
        <div className={css(styles.calculation)}>
            <div className={css(styles.buttonWrapper)}>
                <Button
                    text={buttonLabel}
                    link="#"
                    isPrimary
                    onClick={(e)=>this.handleDoCalculation(e)}
                    isActive={!this.state.showResult}
                    inactiveText={inactiveButtonLabel}
                    isCalculationButton
                    dataLayer={dataLayer}
                />
            </div>
            {this.state.showResult &&
            <div>
                <Title style={styles.title}>{title}</Title>
                <div className={css(styles.resultContainer)}>
                    <div className={css(styles.suggestionContainer)}>
                        <div className={css(styles.flexContainer)}>
                            <h2 className={css(styles.subTitle)}>{totalLabel}</h2>
                            <figure>
                                <img src={amountImage} alt="" className={css(styles.resultImage)} />
                            </figure>
                            
                            {this.state.productWeight &&
                            <div className={css(styles.totalWeightWrapper)}>
                                <div className={css(styles.totalWeight)}>{(Math.round(this.state.productWeight.toString() * 100) / 100).toLocaleString(locale)} {this.state.isImperialSystem ? "LBS" : "kg"}</div>
                                <div className={css(styles.productName)}>{ofLabel }  {this.state.product.entity.fieldBreakdownProductName ? this.state.product.entity.fieldBreakdownProductName : this.state.product.entity.entityLabel}</div>
                            </div>
                            }
                        </div>
                        <div className={css(styles.orLabelWrapper)}>{orLabel}</div>
                        <div className={css(styles.flexContainer)}>
                            <h2 className={css(styles.subTitle)}>{packagedLabel}</h2>
                            <figure>
                                <img src={packageImage} alt="" className={css(styles.resultImage)}/>
                            </figure>
                            {!this.state.isPackagingError && this.state.productPackage && this.state.productPackage.length > 0 &&
                            <div className={css(styles.packagingWrapper)}>
                                {this.state.productPackage.map((pack, index)=>{
                                    return (
                                        <div key={index} className={css(styles.packaging)}>{pack.quantity} x <strong>{pack.entityLabel}</strong></div>
                                    );
                                })}
                                <div className={css(styles.productName)}>{ofLabel }  {this.state.product.entity.fieldBreakdownProductName ? this.state.product.entity.fieldBreakdownProductName : this.state.product.entity.entityLabel}</div>
                            </div>
                            }
                            {this.state.isPackagingError &&
                            <div>No packaging available</div>
                            }
                        </div>
                    </div>

                </div>

                <div className={css(styles.productResultWrapper)}>
                    <Product
                        data={this.state.product}
                        linkTitle={linkTitle}
                        dataLayer={dataLayer}
                        selectedProduct={this.state.product}
                    />
                </div>
                {legalParagraph &&
                <div className={css(styles.legal, styles.legalResult)} dangerouslySetInnerHTML={{__html: legalParagraph}}></div>
                }

                <div className={css(styles.resultButtonWrapper, findDistributorButtonLabel ? styles.resultButtonWrapper : styles.resultButtonWrapperOnly)}>
                    <div className={css(styles.resultButton)}>
                        <ReactToPrint
                            trigger={()=>
                                <Button
                                    text={printButtonLabel}
                                    link="#"
                                    isTransparent
                                    isBlock
                                    typeOfGrout={this.state.product.entity.entityLabel}
                                    trackingEventAction={'print this result'}
                                    dataLayer={dataLayer}
                                    isTracked
                                />}
                            content={()=>printContainerRef}
                        />
                    </div>
                </div>
                {findDistributorButtonLabel &&
                    <div className={css(styles.resultButtonWrapper)}>
                        <div className={css(styles.resultButton)}>
                            <Button
                                text={findDistributorButtonLabel}
                                link={findDistributorLink}
                                isExternalLink
                                isTransparent
                                isBlock
                                typeOfGrout={this.state.product.entity.entityLabel}
                                trackingEventAction={'find a distributor'}
                                dataLayer={dataLayer}
                                isTracked
                            />
                        </div>
                    </div>
                }
                <div className={css(styles.clearfix)}></div>
            </div>
            }
            {legalParagraph && !this.state.showResult &&
            <div className={css(styles.legal)} dangerouslySetInnerHTML={{__html: legalParagraph}}></div>
            }
        </div>
        );
    }
}

export default Calculation;